import { Routes } from '@angular/router';
import {SettingsComponent} from "../modules/settings/settings.component";

// OJO: Solo importa componentes aquí si son *standalone*.
// Si NO son standalone, usa lazy-load de sus módulos.

const Routing: Routes = [
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },

  // Módulos lazy-loaded
  {
    path: 'dashboard',
    loadChildren: () =>
      import('../modules/dashboard/dashboard.module').then(m => m.DashboardModule),
  },
  {
    path: 'pocket_guides',
    loadChildren: () =>
      import('../modules/pocket-guides/pocket-guides.module').then(m => m.PocketGuidesModule),
  },
  {
    path: 'quality_scorecard',
    loadChildren: () =>
      import('../modules/quality-scorecard/quality-scorecard.module').then(m => m.QualityScorecardModule),
  },
  {
    path: 'risk_adjustment_scorecard',
    loadChildren: () =>
      import('../modules/risk-adjustment-scorecard/risk-adjustment-scorecard.module').then(m => m.RiskAdjustmentScorecardModule),
  },
  {
    path: 'change-password',
    loadChildren: () =>
      import('../modules/change-password/change-password.module').then(m => m.ChangePasswordModule),
  },
  {
    path: 'notifications',
    loadChildren: () =>
      import('../modules/notifications/notifications.module').then(m => m.NotificationsModule),
  },
  {
    path: 'patient',
    loadChildren: () =>
      import('../modules/patient/patient.module').then(m => m.PatientModule),
  },
  {
    path: 'schedule',
    loadChildren: () =>
      import('../modules/schedule/schedule.module').then(m => m.ScheduleModule),
  },
  {
    path: 'reports',
    loadChildren: () =>
      import('../modules/reports/reports.module').then(m => m.ReportsModule),
  },
  {
    path: 'invites',
    loadChildren: () =>
      import('../modules/invitesmodule/invites.module').then(m => m.InvitesModule),
  },
  {
    path: 'user-accounts',
    loadChildren: () =>
      import('../modules/accounts/accounts.module').then(m => m.AccountsModule),
  },

  {
    path: 'settings',
    component:SettingsComponent,
    pathMatch: 'full',
  },
  { path: '**', redirectTo: 'error/404' },
];

export { Routing };
